import { Component } from '@angular/core';

@Component({
  selector: 'app-input-layout',
  templateUrl: './input-layout.component.html',
  styleUrls: ['./input-layout.component.scss']
})
export class InputLayoutComponent {

}
